import React from 'react';
import './Node.css';

const Node = () => {
    return (
        <div className="node">
        </div>
    );
};

export default Node;


// WEBPACK FOOTER //
// ./src/components/post/node/Node.js